import React, { useCallback, useEffect, useState } from "react";
import CondominiumList from "../condominium/CondominiumList";
import PropertyStatusCondominium from "./PropertyStatusCondominium";
import { useSelector } from "react-redux";
import { findOneConfig } from "../../helpers/api/condominium";
import {
  Alert,
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Spinner,
} from "reactstrap";
import {
  faExclamationCircle,
  faQuestion,
  faDollarSign,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Feed from "../feed/Feed";
import { Toast } from "../UI/toast/Toast";
import { Message, Or, PreloadState } from "../UI/preloading/PreloadState";
import Visitors from "../visitors/Visitors";
import CondominiumList2 from "../condominium/CondominiumList2";
import SelectProperty from "../properties/SelectProperty";
import OnboardingChecklist from "../onboarding/OnboardingChecklist";
import InitialLoadHelpModal from "../onboarding/InitialLoadHelpModal";
import RewardsStreakWidget from "./RewardsStreakWidget";
import { REWARDS_ENABLED } from "../../helpers/rewardsEnabled";

const Dashboard = () => {
  //
  const { role, hasMultipleProperties } = useSelector(
    (state) => state.auth.user
  );
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { selectedProperty } = useSelector((state) => state.property);
  const [alertVisible, setAlertVisible] = useState(false);
  // Al cerrar el modal de ayuda (que solo sale si falta la carga inicial) se
  // resalta la carga inicial en la guia, como un tutorial.
  const [spotlightInitialLoad, setSpotlightInitialLoad] = useState(false);
  const closeSpotlight = useCallback(() => setSpotlightInitialLoad(false), []);

  useEffect(() => {
    setSpotlightInitialLoad(false);
  }, [selectedCondominium]);

  const [loading, setLoading] = useState(true);

  const loadConfiguration = async () => {
    setLoading(true);
    try {
      const { data } = await findOneConfig(selectedCondominium);
      if (!data.charge_at) {
        setAlertVisible(true);
      }
      setLoading(false);
    } catch (error) {
      Toast.fire({
        title:
          "Ha ocurrido un error al intentar obtener la configuración del condominio, por favor intente de nuevo.",
        type: "error",
      });
      setLoading(false);
    }
  };

  const HandleAlert = (visible) => (
    <Alert color="info" className={`${visible ? "" : "d-none"} shadow-sm`}>
      <Card className="bg-transparent shadow-none p-0">
        <CardHeader className="bg-transparent">
          ¡Actualiza la configuración de tu condominio!
        </CardHeader>
        <CardBody>
          <Container>
            <Row className="px-2">
              <p>
                Recuerda{" "}
                <strong>
                  actualizar la configuración del condominio seleccionado
                </strong>
                , asi podemos brindarte un mejor servicio, para hacerlo has{" "}
                <strong>click</strong> en
                <strong>
                  <Link className="ml-1" to={"/dashboard/config"}>
                    Actualizar configuración del condominio
                  </Link>
                </strong>
              </p>

              <h5 className="mb-2">
                <FontAwesomeIcon icon={faExclamationCircle} className="mr-2" />
                Recuerda, estar actualizado nos ayuda a:
              </h5>
              <ul>
                <li>Creación de cuentas por pagar.</li>
                <li>Mantener la base de datos actualizada.</li>
                <li>Evitar errores.</li>
                <li>
                  Además que mejorará la atención al cliente que podemos
                  ofrecerte.
                </li>
              </ul>
            </Row>
          </Container>
        </CardBody>
      </Card>
    </Alert>
  );

  useEffect(() => {
    if (role === "manager" && selectedCondominium) {
      loadConfiguration();
    } else {
      setLoading(false)
    }
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-75 w-100">
        <Spinner color="primary" size={"sm"} />
      </div>
    );
  }

  if (role === "property") {
    // HO-HU-37: con 2+ propiedades vinculadas, hay que elegir una antes de
    // ver datos de ninguna -- si no, cual se mostraria por defecto seria
    // arbitrario. Con 0-1 (el caso de hoy) hasMultipleProperties es false,
    // asi que esto nunca se muestra y el comportamiento no cambia.
    if (hasMultipleProperties && !selectedProperty) {
      return <SelectProperty />;
    }
    return (
      <>
        <PropertyStatusCondominium />
        {REWARDS_ENABLED && <RewardsStreakWidget />}
        <Feed />
      </>
    );
  }

  if (role === "manager") {
    return (
      <>
        {selectedCondominium && (
          <InitialLoadHelpModal
            key={selectedCondominium}
            onClose={() => setSpotlightInitialLoad(true)}
          />
        )}
        {/* HO-HU-36: la guia de primeros pasos va arriba de todo, pero solo
            aparece con un condominio seleccionado (es su estado lo que guia).
            Sigue visible aunque los seis pasos esten resueltos. */}
        {selectedCondominium && (
          <OnboardingChecklist
            spotlightInitialLoad={spotlightInitialLoad}
            onSpotlightClose={closeSpotlight}
          />
        )}
        {/* <HandleAlert visible={true} /> */}
        <CondominiumList2 />
      </>
    );
  }

  if (role === "safety") {
    return <Visitors />;
  }
};

export default Dashboard;
